import React, { Component } from 'react';
import { Button, Form, Message } from 'semantic-ui-react';
import { func, bool } from 'prop-types';

const initialState = {
  start: '',
  end: '',
  error: null,
};

class DateFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.handleSubmit(this.state.start, this.state.end);
  }

  render() {
    const isInvalid =
      this.state.start === '' ||
      this.state.end === '' ||
      this.state.start > this.state.end;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Group widths={2}>
          <Form.Input
            value={this.state.start}
            name="start"
            onChange={event => this.handleChange(event)}
            type="date"
            fluid
            icon="calendar"
            iconPosition="left"
            label="Start Date"
          />
          <Form.Input
            fluid
            icon="calendar"
            iconPosition="left"
            value={this.state.end}
            name="end"
            onChange={event => this.handleChange(event)}
            label="End Date"
            type="date"
          />
        </Form.Group>

        <Button
          disabled={isInvalid || this.props.loading}
          type="submit"
          color="orange"
        >
          Generate Report
        </Button>
        {this.state.error && (
          <Message negative>{this.state.error.message}</Message>
        )}
      </Form>
    );
  }
}

DateFilter.propTypes = {
  handleSubmit: func.isRequired,
  loading: bool,
};

DateFilter.defaultProps = {
  loading: false,
};

export default DateFilter;



// WEBPACK FOOTER //
// ./src/components/DatePicker.jsx